import React from 'react';
import './ChatbotPage.scss';

const ChatbotPage = () => {
  return (
    <div className="chatbot-page">
      <div className="chatbot-page-container">
        {/* <div className="chatbot-page-header">
          <h1 className="section-title">AI Assistant</h1>
          <p className="section-subtitle">Chat with our AI Assistant for help and information</p>
        </div> */}
        <div className="chatbot-page-content">
          <div className="chatbot-iframe-container">
            <iframe
              src="https://dev.ai.showdigital.in/africa/"
              title="AI Chatbot"
              className="chatbot-iframe"
              allow="microphone; camera"
              sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatbotPage;

